export default __webpack_public_path__ + "static/media/916.ba9723b7.png";